import Hero from './Hero';
import WeekSpecials from './WeekSpecials';
import Testimonials from './Testimonials';
import OurStory from './OurStory';

const Home = () => {
  return (
    <>
      <Hero />
      <WeekSpecials />
      <Testimonials />
      <OurStory />
    </>
  );
};

export default Home;
